import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#65006c',
                secondary: '#ff6138',
                tertiary: '#212121'
            },
        },
    },

})


export default new Vuetify({
});
